import { useFormContext } from "react-hook-form";
import IconGreenCheckmark from "../../Svgs/green-checkmark";
import { useContext } from "react";
import { VerificationFormContext } from "..";
import AppContext from "../../../App/AppContext";
import InsuranceDisclaimer from "../Disclaimers/InsuranceDisclaimer";

const ResponseScreen = () => {
  const form = useFormContext();
  const { state } = useContext(VerificationFormContext);

  const CoverageStatus = state.coverageVerificationData?.CoverageStatus ?? "";

  const { options: { contact_phone_number = "" } = {} } =
    useContext(AppContext);
  const [payer_name] = form?.getValues(["payer_name"]);

  return (
    <div className="cvf__response-screen">
      <IconGreenCheckmark width="40" height="40" />
      <div className="cvf__response-screen--title">
        Thank You for your submission.
      </div>
      {CoverageStatus === "Active" && !!payer_name ? (
        <div className="cvf__response-screen--copy success-msg">
          <strong style={{ color: "#178223", fontWeight: "bold" }}>
            We’ve successfully verified your active coverage with {payer_name}.
          </strong>{" "}
          <br />
          An admissions specialist will reach out shortly to walk through a few
          additional details and confirm what services are covered under your
          plan.
        </div>
      ) : (
        <>
          <div className="cvf__response-screen--copy">
            We’ve received your insurance inquiry, and a member of our team will
            be in touch soon to help guide you through your coverage options and
            plan details.
          </div>
        </>
      )}
      {contact_phone_number && (
        <div className="cvf__response-screen--copy small">
          If you have any questions, please reach out to us at{" "}
          <a href={`tel:${contact_phone_number}`}>{contact_phone_number}</a>.
        </div>
      )}
      <InsuranceDisclaimer />
    </div>
  );
};
export default ResponseScreen;
